"use client";
import { jsxs, jsx } from "react/jsx-runtime";
import Icon from "../../graphics/Icon/Icon.js";
import { useTracking } from "../../../hooks/useTracking.js";
import Group from "../../layout/Group/Group.js";
import { sharedHandler } from "../../../shared/sharedHandler/sharedHandler.js";
import { forwardRef } from "react";
import '../../../assets/Socials.css';const icon = "_icon_1utsi_2";
const SocialsStyles = {
  icon
};
const _Socials = forwardRef((props, ref) => {
  const {
    twitterUrl,
    facebookUrl,
    youtubeUrl,
    linkedInUrl,
    instagramUrl,
    variant = "dark",
    size,
    trackingType,
    ...rest
  } = props;
  const tracker = useTracking();
  const handleClick = (text, url) => {
    var _a;
    (_a = tracker == null ? void 0 : tracker.page) == null ? void 0 : _a.navigate({
      type: trackingType || "footer",
      action: text,
      destination: url
    });
  };
  return /* @__PURE__ */ jsxs(Group, { ...rest, ref, children: [
    twitterUrl && /* @__PURE__ */ jsx(
      Icon,
      {
        className: SocialsStyles.icon,
        name: "BrandX",
        color: variant,
        size,
        href: twitterUrl,
        target: "_blank",
        onClick: () => handleClick("twitter", twitterUrl),
        ariaLabel: "X link"
      }
    ),
    facebookUrl && /* @__PURE__ */ jsx(
      Icon,
      {
        className: SocialsStyles.icon,
        name: "BrandFacebook",
        color: variant,
        href: facebookUrl,
        target: "_blank",
        size,
        onClick: () => handleClick("facebook", facebookUrl),
        ariaLabel: "Facebook link"
      }
    ),
    youtubeUrl && /* @__PURE__ */ jsx(
      Icon,
      {
        className: SocialsStyles.icon,
        name: "BrandYoutube",
        color: variant,
        href: youtubeUrl,
        size,
        target: "_blank",
        onClick: () => handleClick("youtube", youtubeUrl),
        ariaLabel: "YouTube link"
      }
    ),
    linkedInUrl && /* @__PURE__ */ jsx(
      Icon,
      {
        className: SocialsStyles.icon,
        name: "BrandLinkedin",
        color: variant,
        href: linkedInUrl,
        size,
        target: "_blank",
        onClick: () => handleClick("linkedIn", linkedInUrl),
        ariaLabel: "LinkedIn link"
      }
    ),
    instagramUrl && /* @__PURE__ */ jsx(
      Icon,
      {
        className: SocialsStyles.icon,
        name: "BrandInstagram",
        color: variant,
        href: instagramUrl,
        size,
        target: "_blank",
        onClick: () => handleClick("instagram", instagramUrl),
        ariaLabel: "Instagram link"
      }
    )
  ] });
});
_Socials.displayName = "Socials";
const Socials = sharedHandler(_Socials);
Socials.displayName = _Socials.displayName;
export {
  SocialsStyles as S,
  Socials as default
};
